<template>
  <vs-card class="p-3">
    <div class="xl:flex gap-5">
      <MapList style="flex: 1" class="p-5" @changeYear="onChangeYear" />
      <MapLayout style="flex: 3" class="p-5" :year="year" />
    </div>
  </vs-card>
</template>

<script>
import MapList from "./MapList.vue";
import MapLayout from "./MapLayout.vue";

export default {
  components: { MapList, MapLayout },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },

  methods: {
    onChangeYear(value) {
      this.year = value;
    },
  },
};
</script>

<style lang="scss" scoped></style>
